import React, {Component} from 'react';
import {connect} from 'react-redux';
import DispatchOrderForm from './form';
import {Actions} from '../../../common/actions';
import {Dimmer, Loader} from 'semantic-ui-react';

class EditDispatchOrder extends Component {
  componentDidMount() {
    this.props.clearDispatchOrder();
  }
  onSubmit = (formValues) => {
    const {code} = this.props;
    if (code) {
      if (formValues.status === 'E' && formValues.approveOrder !== '') {
        const approveData = {
          'orderId': formValues.orderId,
          'approveOrder': formValues.approveOrder,
          'chassisList': formValues.vehiclesArray.map((veh) => veh.chassis),
        };
        return this.props.approveDispatchOrder(approveData).then(() => {
          this.props.navigateBack();
        });
      }
      return this.props.editDispatchOrder(code, formValues).then(() => {
        this.props.navigateBack();
      });
    }
    return this.props.addDispatchOrder(formValues);
  }
    
  render() {
    const {code, approving} = this.props;
    return (
      <React.Fragment>
        <DispatchOrderForm
          code={code}
          onSubmit={this.onSubmit} />

        {approving &&
          <Dimmer active inverted>
            <Loader inverted inline='centered' content={'Procesando...'} />
          </Dimmer>
        }
      </React.Fragment>
    );
  }
}

const {
  withRouter,
  addDispatchOrder,
  editDispatchOrder,
  clearDispatchOrder,
  approveDispatchOrder,
  navigateBack,
} = Actions;

const mapStateToProps = (state, ownProps) => {
  return {
    'code': ownProps.params && ownProps.params.code,
    'approving': state.dispatchOrderForm.approving,
  };
};

export default withRouter(connect(mapStateToProps,
  {
    addDispatchOrder,
    editDispatchOrder,
    clearDispatchOrder,
    approveDispatchOrder,
    navigateBack,
  })(EditDispatchOrder));
